export class FinanceApplication {
  constructor({
    financeApplicationID = 0,
    orderID = 0,
    financeApplicationDetails = {},
    finGUID = "00000000-0000-0000-0000-000000000000",
    dealerID = 0,
    status = ''
  } = {}) {
    this.financeApplicationID = financeApplicationID;
    this.orderID = orderID;
    this.financeApplicationDetails = financeApplicationDetails;
    this.finGUID = finGUID; 
    this.dealerID = dealerID;
    this.status=status;
  }
}

export function createFinanceApplication(data) {
  return Object.freeze(new FinanceApplication(data));
}
